import { Pipe, PipeTransform } from '@angular/core';

import { duration } from '../helpers';

@Pipe({
  name: 'snDateDuration',
  pure: false,
})
export class SnDateDurationPipe implements PipeTransform {
  public transform(value: number | string, verbose: boolean = false): string {
    return duration(value, verbose);
  }
}
